import runningHttpClient from "../../axios";
import { mainData, UserRateDomain } from "../../models/commonModels";

  export async function getRaitingData(activity:string) {
     try{
        const res = await runningHttpClient.get<mainData>('/api/v1/rate',{params:{a:activity}});
        if(res.status===200){
         return res.data;
        }
     }catch(e){
       
     }finally{

     }
     return null
  }
  